import { render, staticRenderFns } from "./QuizFormSubmitButton.vue?vue&type=template&id=73b809e2&scoped=true&"
import script from "./QuizFormSubmitButton.vue?vue&type=script&lang=js&"
export * from "./QuizFormSubmitButton.vue?vue&type=script&lang=js&"
import style0 from "./QuizFormSubmitButton.vue?vue&type=style&index=0&id=73b809e2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73b809e2",
  null
  
)

export default component.exports